import React, {Component} from 'react';
import {Form, Control, Fieldset, Errors} from 'react-redux-form';
import _ from 'lodash';
import {isRequired, isRfc, minValue, required} from '../field_validations';
import {formatMoney} from 'accounting-js';
import BigFileUpload from '../widgets/big_file_upload';
import Loading from '../loading';
import {confirmAlert} from 'react-confirm-alert';
import {allUpper, toInt} from '../parsers';
import DatePick from '../forms/datepicker';

export default class Financial extends Component {
	render() {
		const {reports, status, match} = this.props;
		const {financial} = reports;
		const {revision} = financial;
		let fc = !!_.find(reports.permissions, (o) => o === 'Create');
		return (
			<div className="columns is-centered">
				{this.state.modalStatusGoalShow &&
				<ModalStatusGoal
					active={this.state.modalStatusGoalShow}
					axisIndex={this.state.axisIndex}
					goalIndex={this.state.goalIndex}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				{this.state.modalStatusActivityShow &&
				<ModalStatusActivity
					active={this.state.modalStatusActivityShow}
					axisIndex={this.state.axisIndex}
					goalIndex={this.state.goalIndex}
					activityIndex={this.state.activityIndex}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				{this.state.modalDocumentGoalShow &&
				<ModalDocumentGoal
					active={this.state.modalDocumentGoalShow}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				{this.state.modalExpensesGoalShow &&
				<ModalExpensesGoal
					active={this.state.modalExpensesGoalShow}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				{this.state.modalMediaActivityShow &&
				<ModalMediaActivity
					active={this.state.modalMediaActivityShow}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				{this.state.modalActorsGoalShow &&
				<ModalActorsGoal
					active={this.state.modalActorsGoalShow}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				{this.state.modalConagoGoalShow &&
				<ModalConagoGoal
					active={this.state.modalConagoGoalShow}
					closeModal={() => this._toggleModal()} {...this.props}
				/>}
				<div className="column">
					{_.map(financial.data.proigualdad_axis, (axis, key) => {
						return (
							<div key={key}>
								<div className="box is-radiusless" onClick={() => this._showAxis(axis.id)}>
									<div className="level">
										<div className="level-left">
											<div className="level-item">
												<div>
													<h6 className="heading has-text-primary">Eje temático</h6>
													<h3 className="title is-6 has-text-primary">{axis.name}</h3>
												</div>
											</div>
										</div>
										<div className="level-right">
											<div className="level-item">
												<span className="icon">
													{this.state.axisId === axis.id && this.state.showAxis ?
														<i className="fa fa-angle-up fa-lg"/>
														: <i className="fa fa-angle-down fa-lg"/>}
												</span>
											</div>
										</div>
									</div>
								</div>
								{this.state.axisId === axis.id && this.state.showAxis ?
									!_.isEmpty(axis.project_goals) ?
										_.map(axis.project_goals, (row, k) => {
											let revisionFinancial = !_.isEmpty(revision.body) ? revision.body : undefined;
											let goalRevision = revisionFinancial && !_.isEmpty(revisionFinancial.goals) && !_.isEmpty(revisionFinancial.goals[row.id]) ? revisionFinancial.goals[row.id] : undefined;
											let goalRevisionAllowEdit = goalRevision && !_.isEmpty(goalRevision.allow_edit) ? (goalRevision.allow_edit === 'true' ? true : false) : undefined;

											let goalStatus = undefined;
											let goalMotive = undefined;
											let validActions = false;
											let goalDocument = undefined;
											let findAgency = undefined;
											let findCdm = undefined;
											let validCdm = false;
											let versionPhaseGoal = undefined;
											let agencyId = undefined;

											let validEditGoal = fc ? (revisionFinancial && goalRevisionAllowEdit !== undefined ? goalRevisionAllowEdit : (revisionFinancial && goalRevisionAllowEdit === undefined ? false : fc)) : false;
											let goalRevisionCdm = undefined;
											let goalRevisionCdmAllowEdit = 'false';
											let validEditGoalCdm = fc;

											if (match.params.modality !== 'modalidad-iii') {
												versionPhaseGoal = row.project_version_phase_goal;
												goalStatus = !_.isEmpty(versionPhaseGoal) ? _.find(_.find(status.data, {id: 2}).statuses, {id: _.toNumber(versionPhaseGoal.status_id)}) : undefined;
												goalMotive = !_.isEmpty(versionPhaseGoal) && goalStatus ? _.find(goalStatus.motives, {id: _.toNumber(versionPhaseGoal.status_motive_id)}) : undefined;
												goalDocument = !_.isEmpty(versionPhaseGoal) && !_.isEmpty(row.project_version_phase_goal.documents) ? _.filter(versionPhaseGoal.documents, {documentable_subtype: 'goal_document'}) : undefined;
												validActions = goalStatus ? (goalStatus.actions === 'delete' ? false : true) : false;
											} else {
												validCdm = !_.isEmpty(financial.agency) && !_.isEmpty(financial.agency[k]) && financial.agency[k].id !== '' ? true : false;
												agencyId = validCdm ? _.toNumber(financial.agency[k].id) : undefined;
												//versionPhaseGoal = !_.isEmpty(row.project_version_phase_goal) ? _.find(row.project_version_phase_goal, {agency_id: financial.data.agency_id}):undefined;
												versionPhaseGoal = Boolean(row.requires_employees) ? (!_.isEmpty(row.project_version_phase_goal) && agencyId ? _.find(row.project_version_phase_goal, {agency_id: agencyId}) : undefined) : (!_.isEmpty(row.project_version_phase_goal) ? _.find(row.project_version_phase_goal, {agency_id: financial.data.agency_id}) : undefined);
												validActions = !_.isEmpty(row.project_version_phase_goal) ? true : false;
												findAgency = validCdm ? _.find(row.project_version_phase_goal, {agency_id: agencyId}) : undefined;
												findCdm = validCdm ? _.find(row.agencies, {id: agencyId}) : undefined;
												goalDocument = !_.isEmpty(row.project_version_phase_goal) && findAgency && !_.isEmpty(findAgency.documents) ? _.filter(findAgency.documents, {documentable_subtype: 'goal_document'}) : undefined;
												goalRevisionCdm = agencyId && revisionFinancial && !_.isEmpty(revisionFinancial.goals) && !_.isEmpty(revisionFinancial.goals[row.id]) && !_.isEmpty(revisionFinancial.goals[row.id].agencies[agencyId]) ? revisionFinancial.goals[row.id].agencies[agencyId] : undefined;
												goalRevisionCdmAllowEdit = goalRevisionCdm && !_.isEmpty(goalRevisionCdm.allow_edit) ? (goalRevisionCdm.allow_edit === 'true' ? true : false) : undefined;
												validEditGoalCdm = fc ? (revisionFinancial && goalRevisionCdmAllowEdit !== undefined ? goalRevisionCdmAllowEdit : (revisionFinancial && goalRevisionCdmAllowEdit === undefined ? false : fc)) : false;
											}

											return [
												<table className="inm-table" key={k}>
													<thead>
													<tr>
														<th>Meta</th>
														<th>Concepto</th>
														{match.params.modality !== 'modalidad-iii' ?
															<th>Estatus</th>
															: null}
														{match.params.modality !== 'modalidad-iii' ?
															<th>Documento Meta</th>
															: null}
														<th>Gastos</th>
														<th>Actores</th>
														{match.params.modality === 'modalidad-i' ?
															<th>CONAGO</th>
															: null}
													</tr>
													</thead>
													<tbody>
													<tr>
														<td style={{width: match.params.modality !== 'modalidad-iii' ? '35%' : '40%'}}>
															<div className="actions">
																<div className="control">
																	<p className="field-notification" style={{
																		backgroundColor: '#fff',
																		top: '-' + 100 + '%',
																		transform: 'translateY(-100%)'
																	}}>
																		<b>Línea de acción</b><br/>
																		{row.line !== null ? row.line.name :'--'}
																	</p>
																	<button type="button"><i className="fa fa-eye"></i>
																	</button>
																</div>
															</div>
															<b>{`(${row.code})`}</b>{row.name}
														</td>

														<td style={{width: match.params.modality !== 'modalidad-iii' ? '10%' : '20%'}}>{row.resource_concept ? row.resource_concept.name : ''}</td>

														{match.params.modality !== 'modalidad-iii' ?
															<td style={{width: 10 + '%', padding: '1em .5em 1em 30px'}}>
																<div className="actions">
																	<div className="control">
																		<p className="field-notification" style={{
																			backgroundColor: '#fff',
																			top: '-' + 100 + '%',
																			transform: 'translateY(-100%)'
																		}}>
																			<b>Estatus</b><br/>
																			{versionPhaseGoal && goalStatus && goalStatus.id !== 1 ?
																				<span
																					className={`has-text-${goalStatus.style}`}>{goalStatus.name}</span> :
																				<span>Sin estatus</span>}<br/>
																			<b>Motivo</b><br/>
																			<span>{versionPhaseGoal && goalStatus && goalMotive ? goalMotive.name : 'N/A'}</span>
																		</p>
																		<button type="button">
																			<i className="fa fa-eye"></i>
																		</button>
																	</div>
																	{validEditGoal &&
																	<button type="button"
																	        onClick={() => this._editStatusGoal(row.id, key, k, versionPhaseGoal)}
																	        style={{cursor: 'pointer'}}>
																		<i className="fa fa-edit"/>
																	</button>}
																</div>
																{versionPhaseGoal && goalStatus && goalStatus.id !== 1 ?
																	<strong>
																		<p className={`has-text-${goalStatus.style}`}>{goalStatus.name}</p>
																	</strong> : <p>Sin estatus</p>}
															</td>
															: null}

														{match.params.modality !== 'modalidad-iii' ?
															<td style={{width: 10 + '%', padding: '1em .5em 1em 30px'}}>
																{this.state.modalMessageDocumentGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
																	<ModalMessageDocumentGoal
																		active={this.state.modalMessageDocumentGoalShow}
																		goalDocument={goalDocument}
																		closeModal={() => this._toggleModal()} {...this.props}/> : ''}
																<div className="actions">
																	<div className="control">
																		<button type="button"
																		        style={{cursor: 'pointer'}}
																		        onClick={() => this._showMessageDocument(key, k)}>
																			<i className="fa fa-eye"></i></button>
																	</div>
																	{validEditGoal && validActions ?
																		<button type="button"
																		        style={{cursor: 'pointer'}}
																		        onClick={() => this._editDocumentGoal(row.id, key, k, versionPhaseGoal)}>
																			<i className="fa fa-edit"/>
																		</button> : ''}
																</div>
																{goalDocument && !_.isEmpty(goalDocument) ?
																	<p><strong>{goalDocument.length}&nbsp;-
																		Documentos</strong></p> : 'Ningún documento'}
															</td>
															: null}

														<td style={{width: 15 + '%', padding: '1em .5em 1em 30px'}}>
															{this.state.modalMessageExpensesGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
																<ModalMessageExpenseGoal
																	active={this.state.modalMessageExpensesGoalShow}
																	amounts={row.amounts} data={versionPhaseGoal}
																	closeModal={() => this._toggleModal()} {...this.props}/> : ''}
															<div className="actions">
																<button style={{cursor: 'pointer'}}
																        onClick={() => this._showMessageExpenses(key, k)}>
																	<i className="fa fa-eye"></i></button>
																{validEditGoal && validActions ?
																	<button type="button" style={{cursor: 'pointer'}}
																	        onClick={() => this._editExpensesGoal(row.id, financial.data.agency_id, key, k, row.requires_employees, versionPhaseGoal, row.agencies)}>
																		<i className="fa fa-edit"></i></button> : ''}
															</div>
															<p className="has-text-inm-purple"><b>Monto ejercido</b></p>
															{formatMoney(row.amounts.spent)}
															<p className="has-text-inm-purple"><b>Monto por ejercer</b>
															</p>
															{formatMoney(row.amounts.missing)}
														</td>

														<td style={{padding: '1em .5em 1em 30px'}}>
															{this.state.modalMessageActorsGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
																<ModalMessageActors
																	active={this.state.modalMessageActorsGoalShow}
																	actors={row.actors}
																	closeModal={() => this._toggleModal()}/> : ''}
															<div className="actions">
																<div className="control">
																	<button type="button" style={{cursor: 'pointer'}}
																	        onClick={() => this._showMessageActors(key, k)}>
																		<i className="fa fa-eye"></i></button>
																	{validEditGoal && validActions ?
																		<button type="button"
																		        style={{cursor: 'pointer'}}
																		        onClick={() => this._editActorsGoal(row.id, key, k, row.actors)}>
																			<i className="fa fa-edit"></i></button>
																		: ''}
																</div>
															</div>
															<b>{`${_.size(row.actors)} actores estratégicos`}</b>
														</td>

														{match.params.modality === 'modalidad-i' ?
															<td style={{padding: '1em .5em 1em 30px'}}>
																{this.state.modalMessageConagoGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
																	<ModalMessageConago
																		active={this.state.modalMessageConagoGoalShow}
																		conago_clauses={row.conago_clauses}
																		closeModal={() => this._toggleModal()}/> : ''}
																<div className="actions">
																	<div className="control">
																		<button type="button"
																		        style={{cursor: 'pointer'}}
																		        onClick={() => this._showMessageConago(key, k)}>
																			<i className="fa fa-eye"></i></button>
																		{validEditGoal && validActions ?
																			<button type="button"
																			        style={{cursor: 'pointer'}}
																			        onClick={() => this._editConagoClausesGoal(row.id, key, k, row.conago_clauses)}>
																				<i className="fa fa-edit"></i></button>
																			: ''}
																	</div>
																</div>
																<b>{`${_.size(row.conago_clauses)} cláusulas CONAGO`}</b>
															</td>
															: null}
													</tr>

													{goalRevision && goalRevision.comment ?
														<tr>
															<td colSpan={7}>
																<div
																	className={`notification ${goalRevision.status ? `is-${goalRevision.status}` : ''}`}>
																	<i className="fa fa-info"/>&nbsp;
																	{goalRevision.comment}
																</div>
															</td>
														</tr>
														: null}

													{match.params.modality === 'modalidad-iii' ?
														<tr>
															<td colSpan={validCdm ? 2 : 7}>
																<h1 className="title is-5">CDM'S</h1>
																<div className="field">
																	<div className="control">
																		<div className="select">
																			<Control.select
																				model={`reports.financial.agency[${k}].id`}
																				name="agency_id" id="agency_id">
																				<option value=""> -- CDM'S --</option>
																				{_.map(row.agencies, (cdm, o) => {
																					let cdmStatus = _.find(row.project_version_phase_goal, {agency_id: cdm.id});
																					return <option key={o}
																					               value={cdm.id}
																					               className={cdmStatus && cdmStatus.status && cdmStatus.status.id !== 1 ? `has-text-${cdmStatus.status.style}` : ''}>{cdm.agenciable && cdm.agenciable.name ? cdm.agenciable.name : '---'}</option>;
																				})}
																			</Control.select>
																		</div>
																	</div>
																</div>
															</td>

															{validCdm ?
																<td style={{padding: '1em .5em 1em 30px'}}>
																	<div className="actions">
																		<div className="control">
																			<p className="field-notification" style={{
																				backgroundColor: '#fff',
																				top: '-' + 100 + '%',
																				transform: 'translateY(-100%)'
																			}}>
																				<b>Estatus</b><br/>
																				{findAgency && findAgency.status && findAgency.status.id !== 1 ?
																					<span
																						className={`has-text-${findAgency.status.style}`}>{findAgency.status.name}</span> :
																					<span>Sin estatus</span>}<br/>
																				<b>Motivo</b><br/>
																				<span>{findAgency && findAgency.status_motive ? findAgency.status_motive.name : 'N/A'}</span>
																			</p>
																			<button type="button">
																				<i className="fa fa-eye"/>
																			</button>
																		</div>
																		{validEditGoalCdm ?
																			<button type="button"
																			        onClick={() => this._editStatusGoalMod(row.id, agencyId, key, k, findAgency, findCdm.agenciable.name)}
																			        style={{cursor: 'pointer'}}>
																				<i className="fa fa-edit"/>
																			</button> : ''}
																	</div>
																	<strong style={{fontSize: '1em'}}>ESTATUS</strong>
																	<br/>
																	{findAgency && findAgency.status && findAgency.status.id !== 1 ?
																		<strong>
																			<p className={`has-text-${findAgency.status.style}`}>{findAgency.status.name}</p>
																		</strong> : <p>Sin estatus</p>}
																</td>
																: null}

															{validCdm ?
																<td style={{padding: '1em .5em 1em 30px'}}>
																	{this.state.modalMessageDocumentGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
																		<ModalMessageDocumentGoal
																			active={this.state.modalMessageDocumentGoalShow}
																			goalDocument={goalDocument}
																			closeModal={() => this._toggleModal()} {...this.props}/> : ''}
																	<div className="actions">
																		<div className="control">
																			<button style={{cursor: 'pointer'}}
																			        onClick={() => this._showMessageDocument(key, k)}>
																				<i className="fa fa-eye"></i></button>
																		</div>
																		{validEditGoalCdm && findAgency ? findAgency.status && findAgency.status.actions === 'delete' ?
																			'' :
																			<button type="button"
																			        style={{cursor: 'pointer'}}
																			        onClick={() => this._editDocumentGoalMod(row.id, agencyId, key, k, findAgency, findCdm.agenciable.name)}>
																				<i className="fa fa-edit"/>
																			</button> : ''}
																	</div>
																	<strong style={{fontSize: '1em'}}>DOCUMENTO
																		META</strong><br/>
																	{/*<strong>{findCdm.agenciable.name}</strong>*/}
																	{goalDocument && !_.isEmpty(goalDocument) ?
																		<p><strong>{goalDocument.length}&nbsp;-
																			Documentos</strong>
																		</p> : 'Ningún documento'}
																</td>
																: null}
														</tr>
														: null}

													{goalRevisionCdm && goalRevisionCdm.comment ?
														<tr>
															<td colSpan={7}>
																<div
																	className={`notification ${goalRevisionCdm.status ? `is-${goalRevisionCdm.status}` : ''}`}>
																	<i className="fa fa-info"/>&nbsp;
																	{goalRevisionCdm.comment}
																</div>
															</td>
														</tr>
														: null}

													<tr>
														<td colSpan={7}>
															<div className="field is-grouped is-grouped-left">
																<div className="control">
																	<button className="button is-primary is-small"
																	        onClick={() => this._activityShow(row.id)}
																	        disabled={match.params.modality === 'modalidad-iii' ? (validCdm ? false : true) : false}>
																		Ver actividades
																	</button>
																</div>
															</div>
															{!_.isEmpty(_.find(this.state.activitiesShow, {goal_id: row.id})) ?
																<table className="inm-table">
																	<thead>
																	<tr>
																		<th>Actividad</th>
																		<th>Estatus</th>
																		<th>Medio de verificación</th>
																	</tr>
																	</thead>
																	<tbody>
																	{_.map(row.project_goal_activities, (item, o) => {
																		let actRevision = undefined;
																		let actRevisionAllowEdit = undefined;
																		let activityStatus = undefined;
																		let activityMotive = undefined;
																		let activityDocument = undefined;
																		let versionPhaseGoalActivity = undefined;
																		let validActionsActivity = undefined;

																		let validEditActivity = fc;

																		if (match.params.modality !== 'modalidad-iii') {
																			actRevision = goalRevision && !_.isEmpty(goalRevision.activities) && !_.isEmpty(goalRevision.activities[item.id]) ? goalRevision.activities[item.id] : undefined;
																			actRevisionAllowEdit = actRevision && !_.isEmpty(actRevision.allow_edit) ? (actRevision.allow_edit === 'true' ? true : false) : undefined;
																			validEditActivity = fc ? (revisionFinancial && actRevisionAllowEdit !== undefined ? actRevisionAllowEdit : (revisionFinancial && actRevisionAllowEdit === undefined ? false : fc)) : false;
																			validActionsActivity = validActions;
																			versionPhaseGoalActivity = item.project_version_phase_goal_activity;
																			activityStatus = !_.isEmpty(versionPhaseGoalActivity) ? _.find(_.find(status.data, {id: 3}).statuses, {id: _.toNumber(versionPhaseGoalActivity.status_id)}) : undefined;
																			activityMotive = !_.isEmpty(versionPhaseGoalActivity) && activityStatus ? _.find(activityStatus.motives, {id: _.toNumber(versionPhaseGoalActivity.status_motive_id)}) : undefined;
																			activityDocument = !_.isEmpty(versionPhaseGoalActivity) && !_.isEmpty(versionPhaseGoalActivity.documents) ? _.filter(versionPhaseGoalActivity.documents, {documentable_subtype: 'verification_media'}) : undefined;
																		} else {
																			validActionsActivity = findAgency ? (findAgency.status && findAgency.status.actions === 'delete' ? false : true) : false;
																			versionPhaseGoalActivity = validCdm ? _.find(item.project_version_phase_goal_activity, {agency_id: _.toNumber(agencyId)}) : undefined;
																			activityStatus = !_.isEmpty(versionPhaseGoalActivity) ? _.find(_.find(status.data, {id: 3}).statuses, {id: _.toNumber(versionPhaseGoalActivity.status_id)}) : undefined;
																			activityMotive = !_.isEmpty(versionPhaseGoalActivity) && activityStatus ? _.find(activityStatus.motives, {id: _.toNumber(versionPhaseGoalActivity.status_motive_id)}) : undefined;
																			activityDocument = !_.isEmpty(versionPhaseGoalActivity) && !_.isEmpty(versionPhaseGoalActivity.documents) ? _.filter(versionPhaseGoalActivity.documents, {documentable_subtype: 'verification_media'}) : undefined;
																			actRevision = goalRevisionCdm && !_.isEmpty(goalRevisionCdm.activities) && !_.isEmpty(goalRevisionCdm.activities[item.id]) ? goalRevisionCdm.activities[item.id] : undefined;
																			actRevisionAllowEdit = actRevision && !_.isEmpty(actRevision.allow_edit) ? (actRevision.allow_edit === 'true' ? true : false) : undefined;
																			validEditActivity = fc ? (revisionFinancial && actRevisionAllowEdit !== undefined ? actRevisionAllowEdit : (revisionFinancial && actRevisionAllowEdit === undefined ? false : fc)) : false;
																		}

																		return [
																			<tr key={o}>
																				<td style={{width: 50 + '%'}}>{item.name}</td>

																				<td style={{
																					width: 20 + '%',
																					padding: '1em .5em 1em 30px'
																				}}>
																					<div className="actions">
																						<div className="control">
																							<p className="field-notification"
																							   style={{
																								   backgroundColor: '#fff',
																								   top: '-' + 100 + '%',
																								   transform: 'translateY(-100%)'
																							   }}>
																								<b>Estatus</b><br/>
																								{versionPhaseGoalActivity && activityStatus && activityStatus.id !== 0 && activityStatus.id !== 1 ?
																									<span
																										className={`has-text-${activityStatus.style}`}>{activityStatus.name}</span> :
																									<span>Sin estatus</span>}<br/>
																								<b>Motivos</b><br/>
																								<span>{versionPhaseGoalActivity && activityStatus && activityMotive ? activityMotive.name : 'N/A'}</span>
																							</p>
																							<button type="button">
																								<i className="fa fa-eye"/>
																							</button>
																						</div>
																						{validEditActivity && validActionsActivity ?
																							<button type="button"
																							        style={{cursor: 'pointer'}}
																							        onClick={() => this._editStatusActivity(item.id, row.id, key, k, o, versionPhaseGoalActivity, agencyId, findCdm ? findCdm.agenciable.name : undefined)}>
																								<i className="fa fa-edit"/>
																							</button> : ''}
																					</div>
																					{versionPhaseGoalActivity && activityStatus && activityStatus.id !== 0 && activityStatus.id !== 1 ?
																						<strong><span
																							className={`has-text-${activityStatus.style}`}>{activityStatus.name}</span></strong> :
																						<span>Sin estatus</span>}
																				</td>

																				<td style={{padding: '1em .5em 1em 30px'}}>
																					{this.state.modalMessageMediaActivityShow && key === this.state.axisIndex && k === this.state.goalIndex && o === this.state.activityIndex ?
																						<ModalMessageMediaActivity
																							active={this.state.modalMessageMediaActivityShow}
																							activityDocument={activityDocument}
																							closeModal={() => this._toggleModal()} {...this.props}/> : ''}
																					<div className="actions">
																						<button
																							style={{cursor: 'pointer'}}
																							onClick={() => this._showMessageMedia(key, k, o)}>
																							<i className="fa fa-eye"></i>
																						</button>
																						{validEditActivity && validActionsActivity ?
																							<button type="button"
																							        style={{cursor: 'pointer'}}
																							        onClick={() => this._editMediaActivity(item.id, row.id, key, k, o, versionPhaseGoalActivity, agencyId, findCdm ? findCdm.agenciable.name : undefined)}>
																								<i className="fa fa-edit"></i>
																							</button> : ''}
																					</div>
																					{!_.isEmpty(item.verification_media) ? item.verification_media.name : ''}<br/><br/>
																					{activityDocument && !_.isEmpty(activityDocument) ?
																						<p>
																							<strong>{activityDocument.length}&nbsp;-
																								Archivos
																								cargados</strong>
																						</p> : 'Ningún archivo cargado'}
																				</td>
																			</tr>,
																			goalRevision && actRevision && actRevision.comment ?
																				<tr key={`rev-${o}`}>
																					<td colSpan={7}>
																						<div
																							className={`notification ${actRevision.status ? `is-${actRevision.status}` : ''}`}>
																							<i className="fa fa-info"/>&nbsp;
																							{actRevision.comment}
																						</div>
																					</td>
																				</tr>
																				: null
																		];
																	})}
																	</tbody>
																</table>
																: ''}
														</td>
													</tr>
													</tbody>
												</table>
											];
										})
										: ''
									: ''}
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	constructor() {
		super();
		this.state = {
			axisId: undefined,
			axisIndex: undefined,
			showAxis: false,
			goalIndex: undefined,
			activityIndex: undefined,
			activitiesShow: [],
			modalStatusGoalShow: false,
			modalStatusActivityShow: false,
			modalDocumentGoalShow: false,
			modalExpensesGoalShow: false,
			modalMediaActivityShow: false,
			modalActorsGoalShow: false,
			modalConagoGoalShow: false,
			modalMessageDocumentGoalShow: false,
			modalMessageMediaActivityShow: false,
			modalMessageExpensesGoalShow: false,
			modalMessageActorsGoalShow: false,
			modalMessageConagoGoalShow: false
		};
	}

	_showAxis(id) {
		let {modality} = this.props.match.params;
		if (modality === 'modalidad-iii') {
			this.props.reset('reports.financial.agency');
		}

		if (id !== this.state.axisId) {
			this.setState({
				axisId: id,
				showAxis: true
			});
		} else {
			this.setState({
				axisId: undefined,
				showAxis: false
			});
		}
	}

	_activityShow(id) {
		let activities = this.state.activitiesShow;

		let foundShow = _.find(activities, {goal_id: id});

		if (!_.isEmpty(foundShow)) {
			let indexShow = _.findIndex(activities, {goal_id: id});

			activities.splice(indexShow, 1);

			this.setState({
				activitiesShow: [
					...activities
				]
			});

		} else {
			this.setState({
				activitiesShow: [
					...activities,
					{goal_id: id, show: true}
				]
			});
		}
	}

	_editStatusGoal(id, indexAxis, indexGoal, versionPhaseGoal) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(versionPhaseGoal)) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoal,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		} else {
			this.props.change(`reports.financial.edit`, {
				project_goal_id: id,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		}

		this.setState({
			modalStatusGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_editStatusGoalMod(id, agencyId, indexAxis, indexGoal, versionPhaseGoal, agencyName) {
		this.props.reset('reports.financial.edit');

		if (versionPhaseGoal !== undefined) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoal,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				agencyName: agencyName
			});
		} else {
			this.props.change(`reports.financial.edit`, {
				project_goal_id: id,
				agency_id: agencyId,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				agencyName: agencyName
			});
		}

		this.setState({
			modalStatusGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_editStatusActivity(id, goal_id, indexAxis, indexGoal, indexActivity, versionPhaseGoalActivity, agencyId, agencyName) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(versionPhaseGoalActivity)) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoalActivity,
				project_goal_id: goal_id,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				indexActivity: indexActivity,
				agencyName: agencyName
			});
		} else {
			this.props.change(`reports.financial.edit`, {
				project_goal_id: goal_id,
				pga_id: id,
				agency_id: agencyId,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				indexActivity: indexActivity,
				agencyName: agencyName
			});
		}

		this.setState({
			modalStatusActivityShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal,
			activityIndex: indexActivity
		});
	}

	_editDocumentGoal(id, indexAxis, indexGoal, versionPhaseGoal) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(versionPhaseGoal)) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoal,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		} else {
			this.props.change('reports.financial.edit', {
				project_goal_id: id,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		}

		this.setState({
			modalDocumentGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_editDocumentGoalMod(id, agencyId, indexAxis, indexGoal, versionPhaseGoal, agencyName) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(versionPhaseGoal)) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoal,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				agencyName: agencyName
			});
		} else {
			this.props.change('reports.financial.edit', {
				project_goal_id: id,
				agency_id: agencyId,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				agencyName: agencyName
			});
		}

		this.setState({
			modalDocumentGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_editExpensesGoal(id, agencyId, indexAxis, indexGoal, requiresEmployees, versionPhaseGoal, agencies) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(versionPhaseGoal)) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoal,
				agency_id: agencyId,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				requiresEmployees: requiresEmployees,
				agencies: agencies
			});
		} else {
			this.props.change('reports.financial.edit', {
				project_goal_id: id,
				agency_id: agencyId,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				requiresEmployees: requiresEmployees,
				agencies: agencies
			});
		}

		this.setState({
			modalExpensesGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_editMediaActivity(id, goal_id, indexAxis, indexGoal, indexActivity, versionPhaseGoalActivity, agencyId, agencyName) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(versionPhaseGoalActivity)) {
			this.props.change(`reports.financial.edit`, {
				...versionPhaseGoalActivity,
				project_goal_id: goal_id,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				indexActivity: indexActivity,
				agencyName: agencyName
			});
		} else {
			this.props.change(`reports.financial.edit`, {
				project_goal_id: goal_id,
				pga_id: id,
				agency_id: agencyId,
				indexAxis: indexAxis,
				indexGoal: indexGoal,
				indexActivity: indexActivity,
				agencyName: agencyName
			});
		}

		this.setState({
			modalMediaActivityShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal,
			activityIndex: indexActivity
		});
	}

	_editActorsGoal(id, indexAxis, indexGoal, actors) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(actors)) {
			this.props.change(`reports.financial.edit`, {
				actors: actors,
				project_goal_id: id,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		} else {
			this.props.change(`reports.financial.edit`, {
				project_goal_id: id,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		}

		this.setState({
			modalActorsGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_editConagoClausesGoal(id, indexAxis, indexGoal, conago_clauses) {
		this.props.reset('reports.financial.edit');

		if (!_.isEmpty(conago_clauses)) {
			this.props.change(`reports.financial.edit`, {
				conago_clauses,
				project_goal_id: id,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		} else {
			this.props.change(`reports.financial.edit`, {
				project_goal_id: id,
				indexAxis: indexAxis,
				indexGoal: indexGoal
			});
		}

		this.setState({
			modalConagoGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_showMessageDocument(indexAxis, indexGoal) {
		this.setState({
			modalMessageDocumentGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_showMessageMedia(indexAxis, indexGoal, indexActivity) {
		this.setState({
			modalMessageMediaActivityShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal,
			activityIndex: indexActivity
		});
	}

	_showMessageExpenses(indexAxis, indexGoal) {
		this.setState({
			modalMessageExpensesGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_showMessageActors(indexAxis, indexGoal) {
		this.setState({
			modalMessageActorsGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_showMessageConago(indexAxis, indexGoal) {
		this.setState({
			modalMessageConagoGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		});
	}

	_toggleModal() {
		this.setState({
			modalStatusGoalShow: false,
			modalStatusActivityShow: false,
			modalDocumentGoalShow: false,
			modalExpensesGoalShow: false,
			modalMediaActivityShow: false,
			modalActorsGoalShow: false,
			modalConagoGoalShow: false,
			modalMessageDocumentGoalShow: false,
			modalMessageMediaActivityShow: false,
			modalMessageExpensesGoalShow: false,
			modalMessageActorsGoalShow: false,
			modalMessageConagoGoalShow: false
		});
		this.props.reset('reports.financial.edit');
	}
}

class ModalStatusGoal extends Component {
	render() {
		const {status, reports, match} = this.props;
		let {financial} = reports;
		let goalsStatus = _.find(status.data, {id: 2});
		let statusFound = _.find(goalsStatus.statuses, {id: _.toNumber(financial.edit.status_id)});
		let goalMotives = financial.edit.status_id ? _.find(goalsStatus.statuses, {id: _.toNumber(financial.edit.status_id)}) : undefined;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Estatus de la meta</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{match.params.modality === 'modalidad-iii' ?
							<h1 className="title is-5">{`CDM - ${financial.edit.agencyName}`}</h1>
							: ''}
						{financial.edit.isFetching ? <Loading/> :
							<Form model={`reports.financial.edit`}
							      onSubmit={(values) => this._submitForm(values)}>
								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="" className="label">Estatus <span
											className="small has-text-danger">*</span></label>
										<div className="select">
											<Control.select
												id={`status_id_${this.props.axisIndex}_${this.props.goalIndex}`}
												changeAction={(model, value) => this._changeStatus(model, value)}
												parser={toInt} model=".status_id"
												errors={{required}} validateOn="change">
												<option value="">--- Estatus ---</option>
												{_.map(goalsStatus.statuses, (stat, k) => {
													return <option value={stat.id} key={k}>{stat.name}</option>;
												})}
											</Control.select>
										</div>
										<Errors model=".status_id" show="touched" wrapper={(props) => <small
											className="help has-text-danger">{props.children}</small>}
										        messages={{required: 'El estatus es obligatorio'}}/>
									</div>
								</div>

								{statusFound && statusFound.actions === 'delete' ?
									<div className="notification is-warning">
										<i className="fa fa-info"/>&nbsp;
										Si seleccionas estatus&nbsp;<strong>{statusFound.name}</strong>&nbsp;
										se deshabilitarán las acciones asociadas a la meta. Si ya has cargado algún
										dato, se eliminará.
									</div>
									: ''}

								{financial.edit.status_id && goalMotives && !_.isEmpty(goalMotives.motives) ?
									<div className="field">
										<div className="control">
											<label htmlFor="" className="label">Motivo <span
												className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select
													id={`status_motive_id_${this.props.axisIndex}_${this.props.goalIndex}`}
													parser={toInt} model=".status_motive_id" errors={{required}}
													validateOn="change">
													<option value="">--- Estatus ---</option>
													{_.map(goalMotives.motives, (stat, k) => {
														return <option value={stat.id} key={k}>{stat.name}</option>;
													})}
												</Control.select>
											</div>
											<Errors model=".status_motive_id" show="touched" wrapper={(props) => <small
												className="help has-text-danger">{props.children}</small>}
											        messages={{required: 'El motivo es obligatorio'}}/>
										</div>
									</div>
									: ''}

								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger"
										        onClick={this.props.closeModal}>
											Cerrar
										</button>
									</div>
									<div className="control">
										<Control.button model={`reports.financial.edit`}
										                className="button is-success"
										                disabled={financial.data.editable ? false : true}>
											Guardar
										</Control.button>
									</div>
								</div>
							</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		);
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}
	}

	_changeStatus(model, value) {
		this.props.change(model, value);
		this.props.change('reports.financial.edit.status_motive_id', '');
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;
		this.props.financialGoalStatusSave(values, financial.data, modality, state, municipality);
	}
}

class ModalStatusActivity extends Component {
	render() {
		const {status, reports, match} = this.props;
		let {financial} = reports;
		let activityStatus = _.find(status.data, {id: 3});
		let activityMotives = financial.edit.status_id ? _.find(activityStatus.statuses, {id: _.toNumber(financial.edit.status_id)}) : undefined;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Estatus de la actividad</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{match.params.modality === 'modalidad-iii' ?
							<h1 className="title is-5">{`CDM - ${financial.edit.agencyName}`}</h1>
							: ''}
						{financial.edit.isFetching ? <Loading/> :
							<Form model="reports.financial.edit"
							      onSubmit={(values) => this._submitForm(values)}>
								<div className="field">
									<div className="control">
										<label htmlFor="" className="label">Estatus <span
											className="small has-text-danger">*</span></label>
										<div className="select">
											<Control.select
												id={`status_id_${this.props.axisIndex}_${this.props.goalIndex}`}
												parser={toInt} model=".status_id" errors={{required}}
												validateOn="change">
												<option value="">--- Estatus ---</option>
												{_.map(activityStatus.statuses, (stat, k) => {
													return <option value={stat.id} key={k}>{stat.name}</option>;
												})}
											</Control.select>
										</div>
										<Errors model=".status_id" show="touched" wrapper={(props) => <small
											className="help has-text-danger">{props.children}</small>}
										        messages={{required: 'El estatus es obligatorio'}}/>
									</div>
								</div>

								{financial.edit.status_id && activityMotives && !_.isEmpty(activityMotives.motives) ?
									<div className="field">
										<div className="control">
											<label htmlFor="" className="label">Motivo <span
												className="small has-text-danger">*</span></label>
											<div className="select">
												<Control.select
													id={`status_motive_id_${this.props.axisIndex}_${this.props.goalIndex}`}
													parser={toInt} model=".status_motive_id" errors={{required}}
													validateOn="change">
													<option value="">--- Estatus ---</option>
													{_.map(activityMotives.motives, (stat, k) => {
														return <option value={stat.id} key={k}>{stat.name}</option>;
													})}
												</Control.select>
											</div>
											<Errors model=".status_motive_id" show="touched" wrapper={(props) => <small
												className="help has-text-danger">{props.children}</small>}
											        messages={{required: 'El motivo es obligatorio'}}/>
										</div>
									</div>
									: ''}

								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger"
										        onClick={this.props.closeModal}>Cerrar
										</button>
									</div>
									<div className="control">
										<Control.button model="reports.financial.edit" className="button is-success"
										                disabled={financial.data.editable ? false : true}>
											Guardar
										</Control.button>
									</div>
								</div>
							</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		);
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		this.props.financialActivityStatusSave(values, financial.data, modality, state, municipality);
	}
}

class ModalDocumentGoal extends Component {
	render() {
		const {reports, match} = this.props;
		const {financial} = reports;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Documentos meta</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{match.params.modality === 'modalidad-iii' ?
							<h1 className="title is-5">{`CDM - ${financial.edit.agencyName}`}</h1>
							: ''}
						{financial.edit.isFetching ? <Loading/> :
							<Form model="reports.financial.edit"
							      onSubmit={(values) => this._submitForm(values)}>
								<p>¿El documento generado da cumplimiento a los requerimientos de las Reglas de
									Operación y fue
									realizado a entera satisfacción?</p>
								<div className="field">
									<div className="control">
										<label htmlFor="comply_rules" className="label">
											<Control.checkbox model=".comply_rules" id="comply_rules" isToggle={true}/>
											Sí
										</label>
									</div>
								</div>

								<p>¿Las temáticas abordadas y las aportaciones realizadas en los eventos desarrollados
									(talleres, mesas de trabajo y otros) fueron incluidas en el documento meta?</p>
								<div className="field">
									<div className="control">
										<label htmlFor="comply_topics" className="label">
											<Control.checkbox model=".comply_topics" id="comply_topics"
											                  isToggle={true}/>
											Sí
										</label>
									</div>
								</div>

								<div className="field has-addons">
									<BigFileUpload
										model=".document"
										name="DOCUMENTO"
										file={financial.edit.document ? financial.edit.document : null}
										size="small"
									/>
									<div className="control">
										<button type="button" className="button is-info is-large"
										        onClick={() => this._addDocument()}
										        disabled={financial.edit.document ? false : true}
										        style={{height: ' 2.55em'}}>
								<span className="icon is-medium">
									<i className="fa fa-plus fa-lg"/>
								</span>
										</button>
									</div>
								</div>

								{!_.isEmpty(financial.edit.documents) ?
									<fieldset className="fieldset">
										<legend>Documentos</legend>
										<table className="inm-table">
											<tbody>
											{_.map(financial.edit.documents, (item, k) => {
												return (
													<tr key={k}>
														<td>{`Archivo - ${k + 1}`}</td>
														<td style={{width: 10 + '%'}}>
															<div className="field is-grouped">
																{item.file ?
																	<div className="control">
																		<a href={item.file} className="button is-info"
																		   target="_blank">
																			<span className="icon"><i
																				className="fa fa-eye"/></span>
																		</a>
																	</div>
																	: ''}
																<div className="control">
																	<div className="button is-danger"
																	     onClick={() => this._getConfirm(k)}
																	     disabled={financial.data.editable ? false : true}>
																		<span className="icon"><i
																			className="fa fa-trash-o"/></span>
																	</div>
																</div>
															</div>
														</td>
													</tr>
												);
											})}
											</tbody>
										</table>
									</fieldset>
									: ''}

								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger"
										        onClick={this.props.closeModal}>Cerrar
										</button>
									</div>
									<div className="control">
										<Control.button model="reports.financial.edit" className="button is-success"
										                disabled={!_.isEmpty(financial.edit.documents) && financial.data.editable ? false : true}>
											Guardar
										</Control.button>
									</div>
								</div>
							</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		);
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				} else if (edit.action === 'delete' && _.isEmpty(edit.documents)) {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}
	}

	_addDocument() {
		let {document} = this.props.reports.financial.edit;

		if (document) {
			this.props.add('reports.financial.edit.documents', document);
			this.props.change('reports.financial.edit.document', undefined);
		}
	}

	_getConfirm(index) {
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el archivo?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeDocument(index)
		});
	}

	_removeDocument(index) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		if (!_.isObject(financial.edit.documents[index])) {
			this.props.remove('reports.financial.edit.documents', index);
		} else {
			this.props.financialGoalDocumentDelete(financial.edit, financial.data, financial.edit.documents[index].id, modality, state, municipality);
		}
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		this.props.financialGoalDocumentSave(values, financial.data, modality, state, municipality);
	}
}

class ModalExpensesGoal extends Component {
	render() {
		const {reports, match} = this.props;
		const {financial} = reports;
		let totalCdms = 0;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Gastos de la meta</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{financial.edit.isFetching ? <Loading/> :
							<Form model="reports.financial.edit"
							      onSubmit={(values) => this._submitForm(values)}>
								{Boolean(financial.edit.requiresEmployees) ?
									<div className="notification is-warning">
										<i className="fa fa-warning"/>&nbsp; Para agregar comprobantes a este eje
										temático, es necesario hacerlo en la sección de <strong>"Personas
										Contratadas"</strong>
									</div>
									: <div className="columns">
										<div className="column">
											<fieldset className="fieldset">
												<legend>AGREGAR CFDI</legend>
												<div className="field is-grouped">
													<BigFileUpload
														model=".pdf"
														name="PDF"
														file={financial.edit.pdf}
														size="small"
														validators={{required}}
														message={{required: 'Falta anexar PDF'}}
													/>

													{!financial.edit.xmlForm ?
														<BigFileUpload
															model=".xml"
															name="XML"
															file={financial.edit.xml}
															size="small"
															validators={{required}}
															message={{required: 'Falta anexar XML'}}
														/>
														: ''}

													<BigFileUpload
														model=".sat"
														name="Validación SAT"
														file={financial.edit.sat}
														size="small"
														validators={{required}}
														message={{required: 'Falta anexar Validación'}}
													/>
												</div>

												{financial.edit.action === 'xml' ?
													<Fieldset model=".xml">
														<div className="field">
															<div className="control">
																<label htmlFor="name" className="label">Nombre(s) <span
																	className="small has-text-danger">*</span></label>
																<Control.text model=".name" id="name" className="input"
																              errors={{isRequired}}
																              validateOn="change"/>
																<Errors model=".name" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{isRequired: 'Debes ingresar tu nombre'}}/>
															</div>
														</div>

														<div className="field is-grouped">
															<div className="control">
																<label htmlFor="rfc" className="label">RFC <span
																	className="small has-text-danger">*</span></label>
																<Control.text model=".rfc" id="rfc" className="input"
																              placeholder="RFC"
																              errors={{isRequired, isRfc}}
																              validateOn="change" parser={allUpper}/>
																<Errors model=".rfc" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'El RFC es obligatorio. ',
																	        isRfc: 'RFC inválido. '
																        }}/>
															</div>

															<div className="control">
																<label htmlFor="date" className="label">Fecha
																	facturación <span
																		className="small has-text-danger">*</span></label>
																<Control model=".date" id="date" className="input"
																         errors={{isRequired}} component={DatePick}/>
																<Errors model=".date" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{isRequired: 'La fecha en la que asumió el cargo es obligatoria. '}}/>
															</div>
														</div>

														<div className="field">
															<div className="control">
																<label htmlFor="concepts"
																       className="label">Concepto <span
																	className="small has-text-danger">*</span></label>
																<Control.text model=".concepts" id="concepts"
																              className="input" errors={{isRequired}}
																              validateOn="change"/>
																<Errors model=".concepts" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{isRequired: 'Debes ingresar el concepto'}}/>
															</div>
														</div>

														<div className="field is-grouped">
															<label htmlFor="subtotal" className="label">Subtotal <span
																className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text model=".subtotal" id="subtotal"
																              className="input" type="number" step=".01"
																              min="0" errors={{
																	isRequired,
																	minValue: minValue(0)
																}} validateOn="change"/>
																<span className="icon is-small is-left"><i
																	className="fa fa-usd"/></span>
																<Errors model=".subtotal" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'Se requiere una cantidad',
																	        minValue: 'Cantidad minima no admitida.'
																        }}/>
															</div>
														</div>

														<div className="field is-grouped">
															<label htmlFor="taxes_withheld" className="label">Impuesto
																retenido <span
																	className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text model=".taxes_withheld"
																              id="taxes_withheld" className="input"
																              type="number" step=".01" min="0" errors={{
																	isRequired,
																	minValue: minValue(0)
																}} validateOn="change"/>
																<span className="icon is-small is-left"><i
																	className="fa fa-usd"/></span>
																<Errors model=".taxes_withheld" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'Se requiere una cantidad',
																	        minValue: 'Cantidad minima no admitida.'
																        }}/>
															</div>
														</div>

														<div className="field is-grouped">
															<label htmlFor="taxes_transferred" className="label">Impuesto
																transferido <span
																	className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text model=".taxes_transferred"
																              id="taxes_transferred" className="input"
																              type="number" step=".01" min="0" errors={{
																	isRequired,
																	minValue: minValue(0)
																}} validateOn="change"/>
																<span className="icon is-small is-left"><i
																	className="fa fa-usd"/></span>
																<Errors model=".taxes_transferred" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'Se requiere una cantidad',
																	        minValue: 'Cantidad minima no admitida.'
																        }}/>
															</div>
														</div>

														<div className="field is-grouped">
															<label htmlFor="taxes_transferred" className="label">Impuesto
																transferido <span
																	className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text model=".taxes_transferred"
																              id="taxes_transferred" className="input"
																              type="number" step=".01" min="0" errors={{
																	isRequired,
																	minValue: minValue(0)
																}} validateOn="change"/>
																<span className="icon is-small is-left"><i
																	className="fa fa-usd"/></span>
																<Errors model=".taxes_transferred" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'Se requiere una cantidad',
																	        minValue: 'Cantidad minima no admitida.'
																        }}/>
															</div>
														</div>

														<div className="field is-grouped">
															<label htmlFor="total_net" className="label">Total
																Neto <span
																	className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text model=".total_net" id="total_net"
																              className="input" type="number" step=".01"
																              min="0" errors={{
																	isRequired,
																	minValue: minValue(0)
																}} validateOn="change"/>
																<span className="icon is-small is-left"><i
																	className="fa fa-usd"/></span>
																<Errors model=".total_net" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'Se requiere una cantidad',
																	        minValue: 'Cantidad minima no admitida.'
																        }}/>
															</div>
														</div>

														<div className="field is-grouped">
															<label htmlFor="total" className="label">Total <span
																className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text model=".total" id="total"
																              className="input" type="number" step=".01"
																              min="0" errors={{
																	isRequired,
																	minValue: minValue(0)
																}} validateOn="change"/>
																<span className="icon is-small is-left"><i
																	className="fa fa-usd"/></span>
																<Errors model=".total" show="touched"
																        wrapper={(props) => <small
																	        className="help has-text-danger">{props.children}</small>}
																        messages={{
																	        isRequired: 'Se requiere una cantidad',
																	        minValue: 'Cantidad minima no admitida.'
																        }}/>
															</div>
														</div>
													</Fieldset>
													: ''}
											</fieldset>

											{match.params.modality === 'modalidad-iii' ?
												<fieldset className="fieldset">
													<legend>DESGLOSE POR CDM</legend>
													<p>Indica el monto gastado en cada instancia. Recuerda que el total
														debe ser igual al monto de la factura cargada.</p>
													<div className="field is-grouped is-grouped-multiline">
														{_.map(financial.edit.agencies, (item, key) => {
															totalCdms += financial.edit.agencies[key].amount ? _.toNumber(financial.edit.agencies[key].amount) : 0;
															return (
																<div className="control" key={key}>
																	<div className="field">
																		<label htmlFor={`agencies_amount_${key}`}
																		       className="label">{item.agenciable.name}
																			<span
																				className="small has-text-danger">*</span></label>
																		<div className="control has-icons-left">
																			<Control.text
																				model={`.agencies[${key}].amount`}
																				id={`agencies_amount_${key}`}
																				className="input" type="number"
																				step=".01" min="0"
																				errors={{minValue: minValue(0)}}
																				validateOn="change"/>
																			<span className="icon is-small is-left"><i
																				className="fa fa-usd"/></span>
																			<Errors model={`.agencies[${key}].amount`}
																			        show="touched"
																			        wrapper={(props) => <small
																				        className="help has-text-danger">{props.children}</small>}
																			        messages={{
																				        isRequired: 'Se requiere una cantidad',
																				        minValue: 'Cantidad minima no admitida.'
																			        }}/>
																		</div>
																	</div>
																</div>
															);
														})}
													</div>
													<div className="field is-grouped is-grouped-right">
														<div className="control">
															<p className="is-size-5">
																<strong>Total:</strong>&nbsp;{formatMoney(totalCdms)}
															</p>
															{totalCdms > 0 ? '' :
																<small className="help has-text-danger">Se requiere una
																	cantidad</small>}
														</div>
													</div>
												</fieldset>
												: ''}

											{!_.isEmpty(financial.edit.invoices) ?
												<fieldset className="fieldset">
													<legend>Facturas</legend>
													<table className="inm-table">
														<thead>
														<tr>
															<th>Factura</th>
															<th>PDF</th>
															<th>XML</th>
															<th>SAT</th>
															<th>Accion</th>
														</tr>
														</thead>
														<tbody>
														{_.map(financial.edit.invoices, (item, k) => {
															return (
																<tr key={k}>
																	<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

																	<td>
																		<div className="control">
																			<a href={item.pdf}
																			   className="button is-info"
																			   target="_blank">
																				<span className="icon"><i
																					className="fa fa-eye"/></span>
																			</a>
																		</div>
																	</td>

																	<td>
																		<div className="control">
																			<a href={item.xml}
																			   className="button is-info"
																			   target="_blank">
																				<span className="icon"><i
																					className="fa fa-eye"/></span>
																			</a>
																		</div>
																	</td>

																	<td>
																		<div className="control">
																			<a href={item.sat}
																			   className="button is-info"
																			   target="_blank">
																				<span className="icon"><i
																					className="fa fa-eye"/></span>
																			</a>
																		</div>
																	</td>

																	<td>
																		<div className="control">
																			<div className="button is-danger"
																			     onClick={() => this._getConfirm(k)}
																			     disabled={financial.data.editable ? false : true}>
																				<span className="icon"><i
																					className="fa fa-trash-o"/></span>
																			</div>
																		</div>
																	</td>
																</tr>
															);
														})}
														</tbody>
													</table>
												</fieldset>
												: ''}

											<div className="field is-grouped is-grouped-right">
												<div className="control">
													<button type="button" className="button is-danger"
													        onClick={this.props.closeModal}>Cerrar
													</button>
												</div>
												<div className="control">
													<Control.button model="reports.financial.edit"
													                className="button is-success"
													                disabled={this._validSubmit(totalCdms)}>
														Guardar
													</Control.button>
												</div>
											</div>
										</div>
									</div>}
							</Form>}
						{Boolean(financial.edit.requiresEmployees) ?
							''
							: <p className="has-text-grey has-text-right is-small">Los campos indicados con <span
								className="small has-text-danger">*</span> son obligatorios.</p>}
					</div>
				</div>
			</div>
		);
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				} else if (edit.action === 'delete' && _.isEmpty(edit.invoices)) {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}

	}

	_getConfirm(index) {
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la factura?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeInvoice(index)
		});
	}

	_removeInvoice(index) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		if (!_.isObject(financial.edit.invoices[index])) {
			this.props.remove('reports.financial.edit.invoices', index);
		} else {
			this.props.financialGoalInvoiceDelete(financial.edit, financial.data, financial.edit.invoices[index].id, modality, state, municipality);
		}
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		this.props.financialGoalInvoicesSave(values, financial.data, modality, state, municipality);
	}

	_validSubmit(totalCdms) {
		let {modality} = this.props.match.params;
		let {financial} = this.props.reports;
		let valid = false;

		if (financial.data.editable) {
			if (modality !== 'modalidad-iii') {
				valid = false;
			} else {
				if (totalCdms > 0) {
					valid = false;
				} else {
					valid = true;
				}
			}
		} else {
			valid = true;
		}

		return valid;
	}
}

class ModalMediaActivity extends Component {
	render() {
		const {reports, match} = this.props;
		const {financial} = reports;//verification_media
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Medio de verificación</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{match.params.modality === 'modalidad-iii' ?
							<h1 className="title is-5">{`CDM - ${financial.edit.agencyName}`}</h1>
							: ''}
						{financial.edit.isFetching ? <Loading/> :
							<Form model="reports.financial.edit" className="modal-card-body"
							      onSubmit={(values) => this._submitForm(values)}>

								<div className="field has-addons">
									<BigFileUpload
										model=".file"
										name="Archivo"
										file={financial.edit.file}
										size="small"
									/>
									<div className="control">
										<button type="button" className="button is-info is-large"
										        onClick={() => this._addDocument()}
										        disabled={financial.edit.file ? false : true}
										        style={{height: ' 2.55em'}}>
								<span className="icon is-medium">
									<i className="fa fa-plus fa-lg"/>
								</span>
										</button>
									</div>
								</div>

								{!_.isEmpty(financial.edit.documents) ?
									<fieldset className="fieldset">
										<legend>Documentos</legend>
										<table className="inm-table">
											<tbody>
											{_.map(financial.edit.documents, (item, k) => {
												return (
													<tr key={k}>
														<td>{`Documento - ${k + 1}`}</td>
														<td style={{width: 10 + '%'}}>
															<div className="field is-grouped">
																{item.file ?
																	<div className="control">
																		<a href={item.file} className="button is-info"
																		   target="_blank">
																			<span className="icon"><i
																				className="fa fa-eye"/></span>
																		</a>
																	</div>
																	: ''}
																<div className="control">
																	<div className="button is-danger"
																	     onClick={() => this._getConfirm(k)}
																	     disabled={financial.data.editable ? false : true}>
																		<span className="icon"><i
																			className="fa fa-trash-o"/></span>
																	</div>
																</div>
															</div>
														</td>
													</tr>
												);
											})}
											</tbody>
										</table>
									</fieldset>
									: ''}

								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger"
										        onClick={this.props.closeModal}>Cerrar
										</button>
									</div>
									<div className="control">
										<Control.button model="reports.financial.edit" className="button is-success"
										                type="submit"
										                disabled={!_.isEmpty(financial.edit.documents) && financial.data.editable ? false : true}>
											Guardar
										</Control.button>
									</div>
								</div>
							</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		);
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				} else if (edit.action === 'delete' && _.isEmpty(edit.documents)) {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}

	}

	_addDocument() {
		let {file} = this.props.reports.financial.edit;

		if (file) {
			this.props.add('reports.financial.edit.documents', file);
			this.props.change('reports.financial.edit.file', undefined);
		}
	}

	_getConfirm(index) {
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el archivo?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeDocument(index)
		});
	}

	_removeDocument(index) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		if (!_.isObject(financial.edit.documents[index])) {
			this.props.remove('reports.financial.edit.documents', index);
		} else {
			this.props.financialActivityMediaDelete(financial.edit, financial.data, financial.edit.documents[index].id, modality, state, municipality);
		}
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		this.props.financialActivityMediaSave(values, financial.data, modality, state, municipality);
	}
}

class ModalActorsGoal extends Component {
	render() {
		const {directories, reports} = this.props;
		let {financial} = reports;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Seleccione los actores estratégicos que aplican</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{financial.edit.isFetching ? <Loading/> :
							<Form model="reports.financial.edit"
							      onSubmit={(values) => this._submitForm(values)}>

								{_.map(directories.actors_groups, (group, key) => {
									let actors = _.filter(directories.actors, {group_id: group.id});

									return (
										<div key={key} className="field">
											<div className="box" style={{
												marginBottom: '-0.6em',
												height: 'auto',
												backgroundColor: '#aaa',
												cursor: 'pointer'
											}} onClick={() => this._showGroup(group.id)}>
												<div className="level">
													<div className="level-left"
													     style={{width: '90%', display: 'inline-block'}}>
														<div className="level-item" style={{display: 'initial'}}>
															<p className="title is-5"
															   style={{color: '#fff'}}>{group.name}</p>
														</div>
													</div>
													<div className="level-right">
														<div className="level-item">
															<span className="icon" style={{color: '#fff'}}>
																{this.state.groupId === group.id && this.state.showGroup ?
																	<i className="fa fa-angle-up"/>
																	: <i className="fa fa-angle-down"/>}
															</span>
														</div>
													</div>
												</div>
											</div>

											{this.state.groupId === group.id && this.state.showGroup ?
												<div className="field is-grouped is-grouped-multiline conago-checkboxes"
												     style={{marginTop: '0.65em'}}>
													{_.map(actors, (actor, k) => {
														let shouldCheck = _.findKey(financial.edit.actors, {id: actor.id}) !== undefined ? true : false;
														//console.log('shouldCheck==>',shouldCheck);
														return (
															<div className="control" key={k}>
																<label htmlFor={`actor-${actor.id}`}
																       className="checkbox"
																       disabled={financial.data.editable ? false : true}>
																	<input type="checkbox"
																	       ref={`g-actor-${actor.id}`}
																	       id={`actor-${actor.id}`}
																	       value={actor.id} checked={shouldCheck}
																	       onChange={() => this._changeCheckBox(actor.id)}
																	       className="checkbox"
																	       disabled={financial.data.editable ? false : true}/>
																	{actor.name}
																</label>
															</div>
														);
													})}
												</div>
												: ''}

										</div>
									);
								})}
								<br/>
								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger"
										        onClick={this.props.closeModal}>Cerrar
										</button>
									</div>
									<div className="control">
										<Control.button model="reports.financial.edit" className="button is-success"
										                disabled={financial.data.editable ? false : true}>
											Guardar
										</Control.button>
									</div>
								</div>
							</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		);
	}

	constructor() {
		super();
		this.state = {
			showGroup: false,
			groupId: undefined
		};
	}

	_showGroup(id) {
		if (id !== this.state.groupId) {
			this.setState({
				groupId: id,
				showGroup: true
			});
		} else {
			this.setState({
				groupId: undefined,
				showGroup: false
			});
		}
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}
	}

	_changeCheckBox(actorId) {
		let {actors} = this.props.reports.financial.edit;

		let actorIndex = _.findIndex(actors, {id: actorId});

		if (this.refs[`g-actor-${actorId}`].checked) {
			if (actorIndex === -1) {
				this.props.add(`reports.financial.edit.actors`, {
					id: actorId
				});
			}
		} else {
			if (actorIndex !== -1) {
				this.props.remove(`reports.financial.edit.actors`, actorIndex);
			}
		}
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		this.props.financialGoalActorsSave(values, financial.data, modality, state, municipality);
	}
}

class ModalConagoGoal extends Component {
	render() {
		const {directories, reports} = this.props;
		let {financial} = reports;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Seleccione las metas que aplican</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{financial.edit.isFetching ? <Loading/> :
							<Form model="reports.financial.edit"
							      onSubmit={(values) => this._submitForm(values)}>

								<div className="field is-grouped is-grouped-multiline conago-checkboxes">
									{_.map(directories.conago, (conago, k) => {
										let shouldCheck = _.findKey(financial.edit.conago_clauses, {id: conago.id}) !== undefined ? true : false;
										return (
											<div className="control" key={k}>
												<label htmlFor={`conago-${conago.id}`} className="checkbox"
												       disabled={financial.data.editable ? false : true}>
													<input type="checkbox"
													       ref={`g-conago-${conago.id}`}
													       id={`conago-${conago.id}`}
													       value={conago.id} checked={shouldCheck}
													       onChange={() => this._changeCheckBox(conago.id)}
													       className="checkbox"
													       disabled={financial.data.editable ? false : true}/>
													{conago.name}
												</label>
											</div>
										);
									})}
								</div>
								<div className="field is-grouped is-grouped-right">
									<div className="control">
										<button type="button" className="button is-danger"
										        onClick={this.props.closeModal}>Cerrar
										</button>
									</div>
									<div className="control">
										<Control.button model="reports.financial.edit" className="button is-success"
										                disabled={financial.data.editable ? false : true}>
											Guardar
										</Control.button>
									</div>
								</div>
							</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		);
	}

	componentWillReceiveProps(newprops) {
		let {edit} = newprops.reports.financial;
		if (edit !== this.props.reports.financial.edit) {
			if (edit.action) {
				if (edit.action === 'close') {
					this.props.closeModal();
					this.props.change('reports.financial.edit.action', undefined);
				}
			}
		}
	}

	_changeCheckBox(conagoId) {
		let {conago_clauses} = this.props.reports.financial.edit;

		let conagoIndex = _.findIndex(conago_clauses, {id: conagoId});

		if (this.refs[`g-conago-${conagoId}`].checked) {
			if (conagoIndex === -1) {
				this.props.add(`reports.financial.edit.conago_clauses`, {
					id: conagoId
				});
			} else {
				this.props.change(`reports.financial.edit.conago_clauses[${conagoIndex}]`, {
					id: conagoId
				});
			}
		} else {
			if (conagoIndex !== -1) {
				this.props.remove(`reports.financial.edit.conago_clauses`, conagoIndex);
			}
		}
	}

	_submitForm(values) {
		let {financial} = this.props.reports;
		let {modality, state, municipality} = this.props.match.params;

		this.props.financialGoalConagoSave(values, financial.data, modality, state, municipality);
	}
}

class ModalMessageDocumentGoal extends Component {
	render() {
		let {goalDocument} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: _.isEmpty(goalDocument) ? 'auto' : ''}}>
					<div className="message">
						<div className="message-header">
							<p>Documentos meta</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<p>El documento generado da cumplimiento a los requerimientos de las Reglas de Operación y
								fue realizado a entera satisfacción</p>
							<br/>
							<p><strong>{goalDocument ? 'Si' : '---'}</strong></p>
							<p>¿Las temáticas abordadas y las aportaciones realizadas en los eventos desarrollados
								(talleres, mesas de trabajo y otros) fueron incluidas en el documento meta?</p>
							<br/>
							<p><strong>{goalDocument ? 'Si' : '---'}</strong></p><br/>
							<p><strong>Archivos</strong></p>
							{goalDocument ?
								_.map(goalDocument, (item, k) => {
									return [
										<a href={item.file} key={k} target="_blank">
											{`Archivo - ${k + 1}`}
										</a>,
										<br key={'br_' + k}/>
									];
								})
								: ''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		);
	}
}

class ModalMessageMediaActivity extends Component {
	render() {
		let {activityDocument} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: _.isEmpty(activityDocument) ? 'auto' : ''}}>
					<div className="message">
						<div className="message-header">
							<p>Medio de verificación</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<p><strong>Archivos</strong></p>
							{activityDocument ?
								_.map(activityDocument, (item, k) => {
									return [
										<a href={item.file} key={k} target="_blank">
											{`Archivo - ${k + 1}`}
										</a>,
										<br key={'br_' + k}/>
									];
								})
								: ''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		);
	}
}

class ModalMessageExpenseGoal extends Component {
	render() {
		let {data, amounts} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content"
				     style={{height: (!_.isEmpty(data) && _.isEmpty(data.invoices)) || (_.isEmpty(data)) ? 'auto' : ''}}>
					<div className="message">
						<div className="message-header">
							<p>Gastos de la meta</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<div className="columns">
								<div className="column is-6">
									<p>Monto aprobado</p>
									<p><strong>{formatMoney(amounts.total)}</strong></p>
								</div>
								<div className="column is-6">
									<p>Monto ejercido</p>
									<p><strong>{formatMoney(amounts.spent)}</strong></p>
								</div>
							</div>

							<div className="columns">
								<div className="column is-6">
									<p>Monto por ejercer</p>
									<p><strong>{formatMoney(amounts.missing)}</strong></p>
								</div>
							</div>

							{!_.isEmpty(data) && !_.isEmpty(data.invoices) ?
								<fieldset className="fieldset">
									<legend>Facturas</legend>
									<table className="inm-table">
										<thead>
										<tr>
											<th>Factura</th>
											<th>PDF</th>
											<th>XML</th>
											<th>SAT</th>
										</tr>
										</thead>
										<tbody>
										{_.map(data.invoices, (item, k) => {
											return (
												<tr key={k}>
													<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

													<td>
														<div className="control">
															<a href={item.pdf} className="button is-info"
															   target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.xml} className="button is-info"
															   target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.sat} className="button is-info"
															   target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>
												</tr>
											);
										})}
										</tbody>
									</table>
								</fieldset>
								: ''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		);
	}
}

class ModalMessageActors extends Component {
	render() {
		let {actors} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Actores estratégicos que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							<ul>
								{_.map(actors, (item, k) => {
									return (
										<li key={k} type="disc"><label className="label">{item.name}</label></li>
									);
								})}
							</ul>

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		);
	}
}

class ModalMessageConago extends Component {
	render() {
		let {conago_clauses} = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Metas conago que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium"
							        aria-label="delete"></button>
						</div>
						<div className="message-body">
							<ul>
								{_.map(conago_clauses, (item, k) => {
									return (
										<li key={k} type="disc"><label className="label">{item.name}</label></li>
									);
								})}
							</ul>

							<br/><br/>
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button"
									        onClick={this.props.closeModal}>Cerrar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/elements/reports/financial.jsx